export class Commission
{
    storeid: string;
    billerid: string;
    rate: string;  
    createdate: string;    
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/commissionmodel.ts